import React, { ReactElement } from 'react';

import UploadLogo from './upload-logo.component';

const UploadFormEmbedFooter = (): ReactElement => {
    return (
        <>
            <div className="mt-12 relative text-center z-10"><UploadLogo /></div>
            <div className="fixed left-0 bottom-0 w-full pb-16 pointer-events-none"
                style={{
                    background: 'linear-gradient(0deg, var(--upload-base-background-color) 28%, rgba(0, 0, 0, 0) 100%)'
                }}
            />
        </>
    );
};

export default UploadFormEmbedFooter;
